import { render, staticRenderFns } from "./KeyDetail.vue?vue&type=template&id=0f7f4d0c&"
import script from "./KeyDetail.vue?vue&type=script&lang=ts&"
export * from "./KeyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./KeyDetail.vue?vue&type=style&index=0&id=0f7f4d0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports